module.exports = __webpack_public_path__ + "img/aaron.c234d7f3.jpg";